import reduxThunkMiddleware from "redux-thunk";
import reduxPromiseMiddleware from "redux-promise-middleware";
import { browserHistory } from "react-router";
import { routerMiddleware } from "react-router-redux";
import redirectionMiddleware from "./redirectionMiddleware";
import googleTagManagerMiddleware from "./googleTagManagerMiddleware";

export default function defaultReduxMiddlewares() {
  const reduxMiddlewares = [
    reduxPromiseMiddleware(),
    reduxThunkMiddleware,
    routerMiddleware(browserHistory),
    redirectionMiddleware,
    googleTagManagerMiddleware,
  ];

  return reduxMiddlewares;
}
